import React, { useState, useRef, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../../services/api';
import { InBoundChartServices } from '../../../services/inbound-chart';
import { Chart } from 'primereact/chart';
import './Marketing.css'
import { format } from "date-fns";

const Marketing = () => {

  const [visible, setVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [marketingSalesList, setMarketingSalesList] = useState([]);
  const [revenueList, setRevenueList] = useState([]);
  const [revenueId, setRevenueId] = useState(null);
  const [revenueColName, setRevenueColName] = useState(null);
  const [revenueColValue, setRevenueColValue] = useState(null);
  const [revenueColumn, setRevenueColumn] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // Add new state variables
  const [selectedLeadSource, setSelectedLeadSource] = useState(null);
  const [leadsDialogVisible, setLeadsDialogVisible] = useState(false);

  const [fieldsData, setFieldsData] = useState('Leads');
  const [sortField, setSortField] = useState(null);

  const toast = useRef(null);

  const handleLeadClick = (field, dataKey, year, lead_source) => {
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + 'lead-source-data', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        field: field,
        dataKey: dataKey,
        year: year,
        lead_source: lead_source
      })
    })
      .then((response) => response.json())
      .then((result) => {
        console.log('-------------->', result.result);
        setSelectedLeadSource(result.result);
        setFieldsData(field);
        setSortField(field === "Leads" ? 'contact_date' :
          field === "Site V" ? 'site_visit_date' :
            field === "CE" ? 'ce_sent_out' :
              field === "Fsa" || field === "NPF" ? 'fsa_date' :
                field === "Cont" ? 'contract_date' :
                  field === "Comp" ? 'completion_date' :
                    'construction_start_date');
        setLeadsDialogVisible(true);
      })
      .catch((error) => {
        console.error('Error:', error);
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch lead data',
          life: 3000
        });
      });
  };

  const leadCountTemplate = (rowData, field) => {
    let displayValue;
    if (field === 'leadCount') {
      displayValue = rowData[field] || rowData.leadCount;
    } else if (field === 'siteVisit') {
      displayValue = rowData[field] || rowData.siteVisit;
    } else if (field === 'CEVisit') {
      displayValue = rowData[field] || rowData.CEVisit;
    } else if (field === 'FsaCount') {
      displayValue = rowData[field] || rowData.FsaCount;
    } else {
      displayValue = rowData[field];
    }

    return (
      <span
        className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline"
        onClick={() => handleLeadClick(
          field === 'leadCount' ? 'Leads' :
            field === 'siteVisit' ? 'Site V' :
              field === 'CEVisit' ? 'CE' :
                field === 'FsaCount' ? 'Fsa' : field,
          'Over All',
          selectedYear,
          rowData.leadTrackerSource
        )}
      >
        {displayValue}
      </span>
    );
  };

  // const [visible, setVisible] = useState(false);

  // const [selectedProduct, setSelectedProduct] = useState(null);
  // const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  // const [marketingSalesList, setMarketingSalesList] = useState([]);
  // const [revenueList, setRevenueList] = useState([]);
  // const [revenueId, setRevenueId] = useState(null);
  // const [revenueColName, setRevenueColName] = useState(null);
  // const [revenueColValue, setRevenueColValue] = useState(null);
  // const [revenueColumn, setRevenueColumn] = useState(null);

  // const [isLoading, setIsLoading] = useState(true);
  // const toast = useRef(null);


  const cities = [
    { name: '2021', value: '2021' },
    { name: '2022', value: '2022' },
    { name: '2023', value: '2023' },
    { name: '2024', value: '2024' },
    { name: '2025', value: '2025' },
    { name: '2026', value: '2026' },
    { name: '2027', value: '2027' },
    { name: '2028', value: '2028' },

    // Add more cities as needed
  ];

  const onYearChange = (e) => {
    setSelectedYear(e.value);// Update selected year state when a year is chosen
    getMarkentingsalesData(e.value);
  };

  const actionBodyTemplate = (rowData) => {

    if (rowData.List === "Revenue" || rowData.List === "Marketing Spend" || rowData.List === "Google Spend") {
      return (
        <React.Fragment>
          <i className="pi pi-pencil" title='Edit Revevenue' style={{ fontSize: '1rem', color: '#4d6da1' }} onClick={() => RevenueEdit(rowData)}></i>
        </React.Fragment>
      );
    } else {
      console.log('rowData', rowData);
      return ''
    }
  };

  const RevenueEdit = (rowData) => {
    if (rowData.List === "Revenue") {
      setRevenueColumn('revenue')
    } else if (rowData.List === "Marketing Spend") {
      setRevenueColumn('marketing_spend')
    } else {
      setRevenueColumn('google_spend')
    }

    setRevenueColName(rowData.List)
    setRevenueColValue(rowData.rValue)

    setVisible(true)
  }



  const customItemTemplate = (option) => (
    <div style={{ padding: '8px' }}>
      {option.name}
    </div>
  );

  // ---------------------------------------------
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);

    // Limit to first 3 data points
    const limitedData = marketingSalesList.slice(0, 3);

    const data = {
      labels: limitedData.map(item => item.leadTrackerSource), // X-axis labels
      datasets: [
        {
          label: 'Lead Count',
          data: limitedData.map(item => item.leadCount), // Data for Y-axis
          backgroundColor: [
            documentStyle.getPropertyValue('--blue-500'), // Color for first entry
            documentStyle.getPropertyValue('--yellow-500'), // Color for second entry
            documentStyle.getPropertyValue('--green-500'), // Color for third entry
          ],
          borderColor: [
            documentStyle.getPropertyValue('--blue-700'), // Border color for first entry
            documentStyle.getPropertyValue('--yellow-700'), // Border color for second entry
            documentStyle.getPropertyValue('--green-700'), // Border color for third entry
          ],
          borderWidth: 1
        }
      ]
    };

    const options = {
      scales: {
        x: {
          beginAtZero: true
        },
        y: {
          beginAtZero: true
        }
      },
      plugins: {
        legend: {
          display: true
        }
      }
    };

    setChartData(data);
    setChartOptions(options);
  }, [marketingSalesList]); // Update when marketingSalesList changes

  // ---------------------------------------------

  useEffect(() => {

    getMarkentingsalesData(selectedYear);
  }, []);


  const getMarkentingsalesData = (year) => {
    setIsLoading(true);
    var _body = {
      year: year
    }
    const token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'crm/marketing-sales', {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {

        setIsLoading(false);
        var x = InBoundChartServices.getMarketingList(response.leads, response.result, year);

        setMarketingSalesList(x);
        if (response.leads.length === 0) {
          var t = InBoundChartServices.getrevenueLeadsEmpty(response.revenue);
          setRevenueId(response.revenue[0].id)

          setRevenueList(t.filter(item => ['Revenue', 'Marketing Spend', 'Google Spend', 'Marketing Spend (% of Revenue)', 'Revenue per Lead Issued (SLI)', 'Cost per Lead',
            //  'ROI from Best Lead Source'
          ].includes(item.List)));
        } else {
          var t = InBoundChartServices.getMarketingAndSeles(response.leads, response.revenue);

          // setRevenueList(t);
          setRevenueList(t.filter(item => ['Revenue', 'Marketing Spend', 'Google Spend', 'Marketing Spend (% of Revenue)', 'Revenue per Lead Issued (SLI)', 'Cost per Lead',
            //  'ROI from Best Lead Source'
          ].includes(item.List)));
          setRevenueId(response.revenue[0].id)
        }

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
    // revenue

  };
  const updateRevenue = () => {
    var _body = {
      column_name: revenueColumn,
      column_value: revenueColValue,
      year: selectedYear,
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'crm/revenue-update', {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        toast.current.show({ severity: 'success', summary: 'Update revenue', detail: 'Revenue Updated Successfully', life: 3000 });
        getMarkentingsalesData(selectedYear)
        setVisible(false)


      })
      .catch((error) => {

        console.error("Error:", error);
      });
  };

  const onRowSelect = (rowData) => {
    console.log('----------->>', rowData.data._id);

    const url = `/lead-edit/${rowData.data._id}`;
    window.open(url,);
  };

  //* ----suraj added for total-----------------------

  const calculateTotals = () => {
    const totals = {
      leadTrackerSource: 'Total',
      leadCount: 0,
      siteVisit: 0,
      SiteVisitPercent: 0,
      CEVisit: 0,
      CEVisitPercent: 0,
      FsaCount: 0,
      FsaCountPercent: 0,
      ContractCount: 0,
      ContractCountPercent: 0,
      rowCount: marketingSalesList.length
    };

    marketingSalesList.forEach(item => {
      totals.leadCount += item.leadCount || 0;
      totals.siteVisit += item.siteVisit || 0;
      totals.SiteVisitPercent += parseFloat(item.SiteVisitPercent) || 0;
      totals.CEVisit += item.CEVisit || 0;
      totals.CEVisitPercent += parseFloat(item.CEVisitPercent) || 0;
      totals.FsaCount += item.FsaCount || 0;
      totals.FsaCountPercent += parseFloat(item.FsaCountPercent) || 0;
      totals.ContractCount += item.ContractCount || 0;
      totals.ContractCountPercent += parseFloat(item.ContractCountPercent) || 0;
    });

    if (totals.rowCount > 0) {
      totals.SiteVisitPercent = totals.SiteVisitPercent / totals.rowCount;
      totals.CEVisitPercent = totals.CEVisitPercent / totals.rowCount;
      totals.FsaCountPercent = totals.FsaCountPercent / totals.rowCount;
      totals.ContractCountPercent = totals.ContractCountPercent / totals.rowCount;
    }

    return totals;
  };

  const DateViewTable = (value) => {
    try {
      var date = new Date(value);
      if (isNaN(date.getTime())) {
        return '';
      }
      var formattedDate = format(date, "y-MM-dd");
      return formattedDate;
    } catch (error) {
      return '';
    }
  }

  const totals = calculateTotals();
  const marketingSalesListWithTotal = [...marketingSalesList, totals];
  //* --------------------------


  return (
    <div className='' >
      <Toast ref={toast} />

      <div className="row justify-content-end">

        <div className='col-6 flex align-items-center justify-content-end'>
          <span >
            <Dropdown inputId="year" options={cities} optionLabel="name" className="w-full md:w-14rem " style={{ height: '40px', padding: '8px' }} itemTemplate={customItemTemplate} value={selectedYear} onChange={onYearChange} />
          </span>
        </div>

      </div>
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <div className='col gap-0'>

          <div className='flex'>
            <div className="col-12">
              <div className="tracking-container flex flex-col justify-between gap-4">
                {revenueList.map((item, index) => (
                  <div key={index} className="tracking-card" >
                    <div className='flex justify-content-between align-items-center'>
                      <h5 className='text-sm font-normal text-gray-600 mb-2'>{item.List}</h5>
                      {/* {(item.List === "Revenue" || item.List === "Marketing Spend" || item.List === "Google Spend") && ( */}
                      {(item.List === "Google Spend") && (
                        <i
                          className="pi pi-pencil"
                          title='Edit Revenue'
                          style={{ fontSize: '0.7rem', color: '#4d6da1', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            RevenueEdit(item);
                          }}
                        ></i>
                      )}
                    </div>
                    <p className='text-center marketing-value' style={{ marginTop: 'auto' }}>{item.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 mt-2">

            <DataTable
              value={marketingSalesList}
              scrollable
              scrollHeight="63vh"
              stripedRows
              selectionMode="single"
              metaKeySelection={false}
              tableStyle={{ fontSize: '14px' }}
              rowClassName={() => 'custom-row-height'}
              footerClassName="custom-footer-row"
            >
              <Column
                style={{ textAlign: 'left', minWidth: '80px' }}
                field="leadTrackerSource"
                header="LEAD SOURCE"
                footer={totals.leadTrackerSource}
              />

              <Column
                style={{ textAlign: 'center', minWidth: '80px' }}
                field="leadCount"
                header="LEADS"
                footer={totals.leadCount}
                body={(rowData) => leadCountTemplate(rowData, 'leadCount')}
              />

              <Column
                style={{ textAlign: 'center', minWidth: '80px' }}
                field="siteVisit"
                header="SQL / SITE VISIT"
                footer={totals.siteVisit}
                body={(rowData) => leadCountTemplate(rowData, 'siteVisit')}
              />

              <Column 
              style={{ textAlign: 'center', minWidth: '80px' }} 
              field="SiteVisitPercent" 
              header="%" 
              footer={() => {
                const siteVisits = totals.siteVisit;
                const leadCount = totals.leadCount;
                const percentage = (siteVisits / leadCount) * 100;

                if (isNaN(percentage)) {
                  return `0%`;
                }
                return `${percentage.toFixed(2)}%`;
              }}>

              </Column>

                <Column
                  style={{ textAlign: 'center', minWidth: '80px' }}
                  field="CEVisit"
                  header="CE"
                  footer={totals.CEVisit}
                  body={(rowData) => leadCountTemplate(rowData, 'CEVisit')}
                />
              

              <Column style={{ textAlign: 'center', minWidth: '80px' }} field="CEVisitPercent" header="CE %" footer={() => {
                const CEVisit = totals.CEVisit;
                const leadCount = totals.leadCount;
                const percentage = leadCount == 0 ? 0 : (CEVisit / leadCount) * 100;
                // if (isNaN(percentage)) {
                //   return `0%`;
                // }
                return `${percentage.toFixed(2)}%`;
              }}>
              </Column>

                <Column
                  style={{ textAlign: 'center', minWidth: '80px' }}
                  field="FsaCount"
                  header="FSA"
                  footer={totals.FsaCount}
                  body={(rowData) => leadCountTemplate(rowData, 'FsaCount')}
                />

              <Column style={{ textAlign: 'center', minWidth: '80px' }} field="FsaCountPercent" header="FSA %" footer={() => {
                const fsaCount = totals.FsaCount;
                const leadCount = totals.leadCount;
                const percentage = leadCount == 0 ? 0 : (fsaCount / leadCount) * 100;
                // if (isNaN(percentage)) {
                //   return `0%`;
                // }
                return `${percentage.toFixed(2)}%`;
              }}>
              </Column>

                <Column
                  style={{ textAlign: 'center', minWidth: '80px' }}
                  field="ContractCount"
                  header="CONTRACT"
                  footer={totals.ContractCount}
                  body={(rowData) => leadCountTemplate(rowData, 'ContractCount')}
                />

              <Column style={{ textAlign: 'center', minWidth: '80px' }} field="ContractCountPercent" header="CONTRACT %" footer={() => {
                const ContractCount = totals.ContractCount || 0;
                const leadCount = totals.leadCount || 0;
                
                // // Handle division by zero and invalid calculations
                // if (leadCount === 0 || ContractCount === 0) {
                //   return '0.00%';
                // }

                const percentage = leadCount == 0 ? 0 : (ContractCount / leadCount) * 100;
                
                // // Check for NaN, Infinity or negative values
                // if (!isFinite(percentage) || isNaN(percentage) || percentage < 0) {
                //   return '0.00%';
                // }

                return `${percentage.toFixed(2)}%`;
              }}>
              </Column>

            </DataTable>


            
          </div>
        </div>
        // </div>

        // </div>
      )}

      <Dialog visible={visible} header={revenueColName} onHide={() => setVisible(false)}>

        <div className='p-3'>
          {/* <p>Add Revevenue</p> */}
          {/* <div>
            <span className="p-float-label p-inputtext-lg my-4">
              <InputText id="list" className='border-x-none border-top-none border-2 border-noround h-3rem' value={revenueColName} onChange={(e) => {

                setRevenueColName(e.target.value);
              }} />
              <label htmlFor="list" >name:</label>
            </span>
          </div> */}

          <div>
            <span className="p-float-label p-inputtext-lg">
              <InputText id="val" className='border-x-none border-top-none border-2 p-2 border-noround h-3rem' value={revenueColValue} onChange={(e) => {

                setRevenueColValue(e.target.value);
              }} />
              <label htmlFor="val" style={{ marginBottom: '20px' }}>Value</label>
            </span>
          </div>

          <div className='flex justify-content-center mt-3'>

            <Button label="Update" onClick={updateRevenue} className='px-5 py-2  customSave-button ' />

          </div>
        </div>

      </Dialog>

      {/* New Dialog */}
      <Dialog
        visible={leadsDialogVisible}
        onHide={() => setLeadsDialogVisible(false)}
        style={{ width: '50vw' }}
        header={`${fieldsData} Details`}
      >
        <DataTable
          value={selectedLeadSource}
          scrollable
          scrollHeight="63vh"
          stripedRows
          selectionMode="single"
          selection={selectedProduct}
          onSelectionChange={e => setSelectedProduct(e.value)}
          metaKeySelection={false}
          tableStyle={{ fontSize: '14px' }}
          rowClassName={() => 'custom-row-height cursor-pointer'} 
          footerClassName="custom-footer-row"
          onRowSelect={onRowSelect}
          selectable
        >
          <Column
            header="#"
            body={(rowData, { rowIndex }) => <span>{rowIndex + 1}</span>}
            style={{ width: '50px', textAlign: 'center' }}
          />

          <Column field="client" header="Client" footer={"TOTAL"} sortable style={{ width: '25%' }} />
          <Column field="address" header="Address"  sortable style={{ width: '25%' }} />
          <Column field="new_status" header="Status"  sortable style={{ width: '20%' }} />
          {/* <Column field="contact_date" header="Contact Date"  sortable style={{ width: '20%' }} /> */}

          <Column
                body={(row) => (
                  <span>
                    {DateViewTable(
                      fieldsData === "Leads" ? row.contact_date.toLocaleString()
                        : fieldsData === "Site V" ? row.site_visit_date
                          : fieldsData === "CE" ? row.ce_sent_out
                            : fieldsData === "Fsa" ? row.fsa_date : fieldsData === "NPF" ? row.fsa_cancelled_date
                              // : fieldsData === "Cont" ? row.contract_date
                                // : fieldsData === "Comp" ? row.completion_date
                                  // : fieldsData === "Cons" ? row.construction_start_date
                                    : row.contract_date
                    )}
                  </span>
                )}
                field={
                  fieldsData === "Leads" ? 'contact_date'
                    : fieldsData === "Site V" ? 'site_visit_date'
                      : fieldsData === "CE" ? 'ce_sent_out'
                        : fieldsData === "Fsa" ? 'fsa_date' : fieldsData === "NPF" ? 'fsa_cancelled_date'
                          // : fieldsData === "Cont" ? 'contract_date'
                            // : fieldsData === "Comp" ? 'completion_date'
                              // : fieldsData === "Cons" ? 'construction_start_date'
                                : 'contract_date'
                }
                header={
                  fieldsData === "Leads" ? "Contact Date"
                    : fieldsData === "Site V" ? "First Meeting Date"
                      : fieldsData === "CE" ? "CE Sent Out"
                        : fieldsData === "Fsa" ? "FSA Sign Date" : fieldsData === "NPF" ? "FSA Cancelled Date"
                          // : fieldsData === "Cont" ? "Contract Date"
                            // : fieldsData === "Comp" ? "Completion Date"
                              // : fieldsData === "Cons" ? "Construction Start Date"
                                : "Contract Date"
                }
                sortable
                style={{ width: '20%', textAlign: 'center' }}
              >
              </Column>          

          <Column 
            field="project_value" 
            header="Project Value" 
            body={(rowData) => {
              const value = parseFloat(rowData.project_value) || 0;
              return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              });
            }}
            footer={() => {
              const total = selectedLeadSource?.reduce((sum, row) => {
                const value = parseFloat(row.project_value) || 0;
                return sum + value;
              }, 0);
              return total.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              });
            }}
            sortable 
            style={{ width: '20%' }} 
          />
          
        </DataTable>
      </Dialog>

    </div>
  )
}

export default Marketing